import { createRequestActions as request } from 'store/actionCreators'

export const setActivityRepeat = request('ACTIVITY/SET_ACTIVITY_REPEAT', ({ activityId, isRepeating }) => ({
  request: {
    url: `/protrack-levels-progress/activity/${activityId}/repeat`,
    method: 'POST',
    data: { isRepeating },
  },
}))

export const setStory = request('ACTIVITY/SET_STORY', ({ activityId, story, mentions, userActivityId }) => ({
  request: {
    url: '/activities-users-stories',
    method: 'POST',
    data: {
      activityId,
      story,
      mentions,
      userActivityId,
    },
  },
}))
